import Divider from '@shared/components/Divider/Divider';
import SearchInput from '@shared/components/SearchInput/SearchInput';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Users } from 'assets/icons/Users.svg';
import SettingsCard from 'modules/SettingsModal/SettingsCard/SettingsCard';
import { SetState } from 'utils/types';

import MembersList from './MembersList';

interface MembersSectionProps {
  onMemberSelect: SetState<string | null>;
}

const MembersSection = ({ onMemberSelect }: MembersSectionProps) => {
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState('');

  const resetSearch = () => setSearchValue('');

  return (
    <SettingsCard>
      <div className="w-full h-full p-2">
        <SettingsCard.Header title={t('workspaces.workspace_members')} icon={Users} />
        <SettingsCard.Content className="pb-0">
          <SearchInput
            placeholder={t('workspaces.search_members')}
            onChange={setSearchValue}
            variant="white-bg"
            size="sm"
            iconPlacement="left"
            iconClassName="!h-5 !w-5 stroke-grayscale-gray70"
            reset={resetSearch}
          />
          <Divider verticalSpace="md" />
          <div className="flex flex-col -mx-2">
            <MembersList searchValue={searchValue} onMemberSelect={onMemberSelect} />
          </div>
        </SettingsCard.Content>
      </div>
    </SettingsCard>
  );
};

export default MembersSection;
